import { render, staticRenderFns } from "./newDayCleanConfig.vue?vue&type=template&id=6761169e&scoped=true"
import script from "./newDayCleanConfig.vue?vue&type=script&lang=js"
export * from "./newDayCleanConfig.vue?vue&type=script&lang=js"
import style0 from "./newDayCleanConfig.vue?vue&type=style&index=0&id=6761169e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6761169e",
  null
  
)

export default component.exports